// src/components/WhatsAppFloat.jsx
import React from "react";
import { Fab, Tooltip, Zoom } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

/* ===== Configurações fixas ===== */
const WA_PHONE = "5511998859120";
const WA_TEXT =
  "Olá, encontrei vocês pelo site e quero mais informações.";
const SIDE = "right";           // "right" ou "left"
const OFFSET = 24;              // distância lateral em px
const BOTTOM = 24;              // distância do bottom em px
const COLOR = "#25D366";
const HOVER_COLOR = "#055726ff";
// Ajuste opcional de tamanhos; deixe como está se quiser o padrão do MUI
const FAB_SIZE = null;          // número em px (ex.: 64) ou null para padrão
const ICON_PX = null;           // número em px (ex.: 36) ou null para "large"

/* ===== Util ===== */
function buildWaLink(phone, text) {
  const digits = (phone || "").replace(/\D/g, "");
  const msg = encodeURIComponent(text || "");
  return `https://wa.me/${digits}${msg ? `?text=${msg}` : ""}`;
}

export default function WhatsAppFloat() {
  const href = buildWaLink(WA_PHONE, WA_TEXT);

  const fabStyle =
    typeof FAB_SIZE === "number"
      ? { width: FAB_SIZE, height: FAB_SIZE, minHeight: FAB_SIZE }
      : {};

  const iconProps =
    typeof ICON_PX === "number"
      ? { sx: { fontSize: ICON_PX } }
      : { fontSize: "large" };

  return (
    <Zoom in timeout={400}>
      <Tooltip title="Fale conosco no WhatsApp" placement={SIDE === "right" ? "left" : "right"}>
        <Fab
          aria-label="WhatsApp"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            position: "fixed",
            bottom: BOTTOM,
            ...(SIDE === "right" ? { right: OFFSET } : { left: OFFSET }),
            zIndex: (t) => t.zIndex.tooltip + 1,
            bgcolor: COLOR,
            color: "#fff",
            "&:hover": { bgcolor: HOVER_COLOR },
            boxShadow: "0 10px 24px rgba(37,211,102,.35)",
            "@media print": { display: "none" },
            ...fabStyle,
          }}
        >
          <WhatsAppIcon {...iconProps} />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}
